import { useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentApi } from '../services/paymentApi';
import { useHybridAuth } from './useHybridAuth';

export function useRefreshPaymentStatus(
  dispatchId?: string,
  companyId?: string
) {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useHybridAuth();

  return useMutation({
    mutationFn: async (invoiceId: string) => {
      if (!companyId) {
        throw new Error('Company ID is required');
      }
      const token = await getAccessTokenSilently();
      return paymentApi.refreshPaymentStatus(invoiceId, companyId, token);
    },
    onSuccess: () => {
      if (dispatchId && companyId) {
        queryClient.invalidateQueries({
          queryKey: ['payment-status', dispatchId, companyId],
        });
      }
    },
  });
}
